import { render, staticRenderFns } from "./AllianceProfileComponent.vue?vue&type=template&id=3a727a5e&scoped=true&"
import script from "./AllianceProfileComponent.vue?vue&type=script&lang=js&"
export * from "./AllianceProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./AllianceProfileComponent.vue?vue&type=style&index=0&id=3a727a5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a727a5e",
  null
  
)

export default component.exports